export const authRouteNames = [
  'loginWithEmail', 'signup', 'signupWithEmail', 'login',
  'forgotPassword', 'forgotPasswordSuccess',
  'confirmEmail', 'verifyEmail', 'confirmEmployeeType', 'confirmEmailSuccess',
  'resetPassword', 'resetPasswordSuccess',
]
